import { render } from "./GettingStarted.vue?vue&type=template&id=19d49f14"
const script = {}
script.render = render

export default script